export const shortenString = (origin: string, from: number, to: number) => {
  if (!origin) return "";
  if (origin.length < from + to) return origin;
  return origin.slice(0, from) + "..." + origin.slice(-1 * to);
};

export const isWalletAddress = (address: string) => {
  return /^0x[a-fA-F0-9]{40}$/.test(address);
};
